export default __webpack_public_path__ + "static/media/ProductsList_PC_img1_Hk.72bc40f4.webp";